import React from 'react';
import Box from "@mui/material/Box";
import "./CoachingPage.css"
import {contentTexts} from "../ContentText";
import CoachingContentBox from "./CoachingContentBox";
import TopTitle from "../Components/TopTitle";
import SubTitle from "../Components/SubTitle";

function CoachingPage(props) {
    return (
        <Box className="coaching_content" ref={props.refs}>
            <Box className="flexColumnCenter">
                <TopTitle>{contentTexts.coachingTitle}</TopTitle>
                <SubTitle>{contentTexts.coachingSubtitle}</SubTitle>
            </Box>

            <Box
                className="coaching_text_content"
                sx={{
                    display: "grid",
                    gap: 3,
                    justifyContent: "center",
                    gridTemplateColumns: {
                        xs: "1fr",
                        md: "repeat(2, minmax(282px, 1fr))",
                        lg: "repeat(4, minmax(282px, 1fr))"
                    }
                }}
            >
                {contentTexts.coachingContent.map((value, index) => (
                    <CoachingContentBox key={index} {...value} />
                ))}
            </Box>
        </Box>
    );
}

export default CoachingPage;
